export const ONE_MINUTE_MS = 60 * 1000
export const ONE_DAY_MS = 24 * 60 * 60 * 1000

export const SCALE_BREAKPOINTS = {
  1: 1,
  600: 2,
  768: 3,
  1240: 4,
  1640: 5,
} as const
